module.exports = __webpack_public_path__ + "img/madera1.35fff922.jpg";